import React from 'react';
import saavi from '../../../../assets/SNR_BNFTS_V1/img/saavi.png';
import AnchorAdv from '../../../UI/AnchorAdv';
const SNR_BNFTS_V3_Header = ({ heading, textContent }) => {
  return (
    <>
      <header className="py-3 mb-3 border-bottom">
        <div className="container text-center">
          <AnchorAdv dataId="SITE_LOGO" className="d-inline-block">
            <img src={saavi} alt="Saavy Finances Logo" height="50" />
          </AnchorAdv>
        </div>
      </header>
    </>
  );
};
export default SNR_BNFTS_V3_Header;
